<template>
  <div class="profile-page" v-if="is_load">
    <section class="section-profile-cover section-shaped my-0">
      <div class="shape shape-style-1 shape-primary shape-skew alpha-4"
           style="background: url(/img/header_bg.jpg) !important;">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </section>
    <section class="section section-skew">
      <div class="container">
        <card shadow class="card-profile mt--300" no-body>
          <div class="row mt-3 ml-3">
            <div class="col-md-8 ">
              <h4>Счет #{{ invoice.last_id }}</h4>
              <p v-if="type=='client' && invoice.ispay==0 && invoice.payment_data && invoice.payment_data.url_pay">
                <a class="btn btn-warning" :href="invoice.payment_data.url_pay">{{ invoice.payment_data.title}}</a>

              </p>
              <div class="h6 font-weight-300"><i class="fa fa-calendar mr-2"></i>{{ invoice.created_at }}

              </div>

              <div class="h6 font-weight-300">
                <p>Описание</p>
                <p>{{ invoice.title }}</p>
              </div>

              <h3>Сумма счета {{ invoice.sum }} <i>{{ currencys_title[invoice.currency]}}</i></h3>
              <card class="col-12" v-if="invoice.developer.account && invoice.ispay==0">
                <p>Реквизиты:</p>
                <p>&nbsp;</p>
                <p>{{ invoice.developer.account }}</p>

              </card>
              <card class="col-12" v-if="order.order && order.items && order.items.length>0">
                <div v-if="type=='client' && invoice.developer.username && invoice.developer.username.length>0">
                  <p><strong>Связаться с исполнителем</strong>:<a target="_blank" :href="'https://t.me/'+invoice.developer.username">{{ invoice.developer.name}}</a></p>

                </div>
                <div v-if="type=='developer' && invoice.client.username && invoice.client.username.length>0">
                  <p><strong>Связаться с клиентом</strong>:<a target="_blank" :href="'https://t.me/'+invoice.client.username">{{ invoice.client.name}}</a></p>

                </div>
                <p v-if="invoice.ispay==1"><strong>Статус оплаты</strong> :заказ {{ order.order.id}} оплачен</p>
                <p v-if="invoice.ispay==1"><strong>Кодовое слово</strong>:{{ order.order.secretId}}</p>
                <p v-if="invoice.ispay==0"><strong>Статус оплаты</strong> :заказ {{ order.order.id}} неоплачен</p>


                <h4 v-if="order.order.client_data"><strong>Данные клиента</strong></h4>
                <p   v-for="(client_field,client_field_key) in order.order.client_data" :key="client_field_key"
                       v-if="order.order.client_data"><strong>{{ client_field.title}}</strong> {{ client_field.value}}</p>

                <p>Содержимое заказа:</p>
                <div   v-for="(item,item_key) in order.items" :key="item_key"
                     v-if="order.items.length>0">
                  <p><b>{{ item.title}} </b> - {{ item.custom_price}} {{ item.currency}}</p>

                  <p v-if="item.confirm_options.length>0" v-for="(confirm_option,cf_key) in item.confirm_options" :key="cf_key">
                    <b>{{  confirm_option.title}}</b>
                  </p>
                  <p>Итого {{ item.custom_price}} x {{ item.count}} = {{ item.total_price}} {{ item.currency}} </p>

                </div>

                <div class="col-md-12 center-block mt-5" >
                  <sui-comment-group size="massive" threaded>
                    <h3 is="sui-header" dividing>Общение между клиентом и исполнителем:</h3>

                    <sui-comment v-if="order.comments && order.comments.length>0" v-for="(comment,comment_index) in order.comments" :key="comment.last_id">
                      <sui-comment-avatar v-if="comment.user.avatar" :src="image_url+comment.user.avatar"/>
                      <div class="avatar" v-if="comment.user.avatar==null">

                        <avatar v-if="comment.user.avatar==null" :size="35" :username="comment.user.name"
                                class="rounded-circle"></avatar>

                      </div>


                      <sui-comment-content>
                        <a is="sui-comment-author">{{ comment.user.name }}</a>
                        <sui-comment-metadata>
                          <div>{{ comment.created_at }}</div>


                        </sui-comment-metadata>
                        <sui-comment-text>{{ comment.comment }}</sui-comment-text>

                      </sui-comment-content>

                    </sui-comment>


                    <h3 is="sui-header" dividing>Написать комментарий</h3>
                    <div class="alert alert-danger" v-if="new_comment_is_error==true">
                      <p>{{ new_comment_error }}</p>
                    </div>


                    <div class="row pt-2 pb-2">
                      <div class="col-md-8">
                        <label for="exampleTitle">Комментарий </label>
                        <textarea  class="form-control" required id="exampleTitle" v-model="newComment.comment"
                                   placeholder="Введите комментарий"></textarea>
                      </div>
                      <div class="col-md-4">
                        <label for="exampleTitle"></label>
                        <button class=" btn side4" @click="sendComment">Отправить комментарий</button>
                      </div>
                    </div>


                  </sui-comment-group>
                </div>
              </card>
              <div class="row alert alert-danger" v-if="invoice.developer.account==null && invoice.ispay==0">
                <p>Исполнитель не заполнил реквизиты, сообщите ему об этом</p>


              </div>


            </div>
            <div class="col-md-4">
              <base-button v-if="type=='client' && invoice.client_pay==0 && invoice.ispay==0" @click="invoiceSetPay()" type="info" size="sm"
                           class="mr-4">Я оплатил счет
              </base-button>

              <base-button v-if="type=='developer'  && invoice.ispay==0"
                           @click="invoiceFinishPay()" type="default" size="sm"
                           class="mr-4">Я получил деньги
              </base-button>

              <badge v-if="type=='developer' && invoice.ispay==1" type="info">счет оплачен</badge>

              <select @change="setNewStatus" class="row form-control" v-model="order.order.status_id" v-if="type=='developer' && invoice.ispay==1" >
                <option   v-for="(status,status_key) in order.statuses" :key="status_key"
                          v-if="order.statuses.length>0" :value="status.last_id">{{ status.title}}</option>
              </select>
              <p v-if="type=='client' && order && order.order &&  order.order.status">{{order.order.status.title}}</p>


            </div>

          </div>

          <div class="col-md-10 m-5"
               v-if="invoice.ispay==1 &&((type=='developer' && invoice.developer_is_review==0) || (type=='client' && invoice.client_is_review==0) )">

            <h3 is="sui-header" dividing>Оставить отзыв</h3>
            <div class="alert alert-danger" v-if="is_error==true">
              <p>{{ error_message }}</p>
            </div>

            <div class="row">
              <div class="col-md-6">
                          <textarea class="row form-control"
                                    v-model="newreview.review"></textarea>
              </div>

              <div class="form-group col-md-4">

                <sui-rating :rating="newreview.rating" @rate="changeRate" :max-rating="5"/>


              </div>

              <div class="col-md-2">
                <button class="btn btn-success" @click="sendReview"><i
                    class="fa fa-arrow-circle-right"></i></button>
              </div>
            </div>

          </div>


        </card>
      </div>
    </section>
  </div>
</template>
<script>
import {eventBus} from "@/main";
import axios from "axios";
import Vue from "vue";
import Api from "../models/Api";

export default {
  data() {
    return {
      "type": "client",
      'invoice': null,
      'order':null,
      'is_load': false,
      "image_url":"",
      "newreview": {
        "review": null,
        "rating": null,
      },
      "new_comment_is_error":false,
      "new_comment_error":"",
      "newComment":{
        "comment":""
      },

      "is_error": false,
      "error_message": null,
      "type_currencys":[],
      "currencys_title":[],


    }
  },
  methods: {
    sendComment(){
      event.preventDefault();
      var app = this;
      var newComment = app.newComment;
      Api.addShopOrderComment(newComment, app.invoice.last_id,app.order.order.id, function (result_comment) {
        app.new_comment_is_error = false;

        app.newComment.comment = "";
        app.order.comments.push(result_comment)
      }, function (message) {
        app.new_comment_is_error = true;
        app.new_comment_error = message;
      })
    },
    invoiceFinishPay() {
      var app = this;
      var id = app.invoice.last_id
      Api.invoiceFinishPay(id, function () {
        app.invoice.ispay = 1;
      })

    },
    sendReview() {
      var app = this;
      Api.sendReview(app.newreview, app.invoice.last_id, function (data) {
        app.invoice = data.invoice;
      }, function (message) {
        app.is_error = true;
        app.error_message = message;
      })
    },
    changeRate(evt, props) {
      this.newreview.rating = props.rating;
    },
    setNewStatus() {
      var app = this;
      var status = app.order.order.status_id;
      Api.setShopNewStatus(status, app.invoice.last_id,app.order.order.id, function () {

      });
    },
    invoiceSetPay() {

      var app = this;
      var id = app.invoice.last_id
      Api.invoiceSetPay(id, function () {
        app.invoice.client_pay = 1;
      });

    }
  },

  mounted() {
    var app = this;
    app.type_currencys=Vue.config.currencys;
    app.currencys_title=Vue.config.currencys_title;
    let id = app.$route.params.id;
    app.image_url = Vue.config.IMAGE_URL;
    Api.loadInvoice(id);
    eventBus.$on('is_load_invoice', data => {


      app.user = data.user;
      app.order=data.order;
      app.invoice = data.invoice;
      if (app.user.last_id == data.invoice.developer_id) {
        app.type = "developer";
      }
      if (app.user.last_id == data.invoice.client_id) {
        app.type = "client";
      }
      app.is_load = true;


    });
  }
}
</script>